import { Link } from 'react-router-dom';
import { Phone, EnvelopeSimple, MapPin, InstagramLogo, FacebookLogo } from '@phosphor-icons/react';

export default function Footer() {
  return (
    <footer className="bg-desti-surface border-t border-white/5" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="font-heading text-2xl text-white tracking-tight">
              Desti<span className="text-desti-gold">Driving</span>
            </Link>
            <p className="mt-4 text-sm text-desti-text leading-relaxed">
              Votre service de chauffeur prive premium a Paris et en Ile-de-France. Confort, securite et ponctualite 24/7.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="https://www.instagram.com/destidriving_/" target="_blank" rel="noreferrer" className="text-white/40 hover:text-desti-gold transition-colors" aria-label="Instagram">
                <InstagramLogo size={22} weight="light" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-desti-gold mb-6">Navigation</h4>
            <div className="space-y-3">
              {[
                { label: 'Accueil', path: '/' },
                { label: 'Presentation', path: '/presentation' },
                { label: 'Services VTC', path: '/service-vtc' },
                { label: 'Avis clients', path: '/avis' },
                { label: 'Contact', path: '/contact' },
              ].map((item) => (
                <Link key={item.path} to={item.path} className="block text-sm text-white/50 hover:text-white transition-colors">
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-desti-gold mb-6">Services</h4>
            <div className="space-y-3">
              {['Transferts Aeroport', 'Transport d\'Affaires', 'Evenements & Soirees', 'Longue distance'].map((s) => (
                <Link key={s} to="/service-vtc" className="block text-sm text-white/50 hover:text-white transition-colors">{s}</Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-desti-gold mb-6">Contact</h4>
            <div className="space-y-4">
              <a href="tel:0635133133" className="flex items-center gap-3 text-sm text-white/50 hover:text-white transition-colors">
                <Phone size={16} weight="light" className="text-desti-gold" />
                06 35 13 31 33
              </a>
              <a href="mailto:contact@destidriving.fr" className="flex items-center gap-3 text-sm text-white/50 hover:text-white transition-colors">
                <EnvelopeSimple size={16} weight="light" className="text-desti-gold" />
                contact@destidriving.fr
              </a>
              <div className="flex items-start gap-3 text-sm text-white/50">
                <MapPin size={16} weight="light" className="text-desti-gold mt-0.5" />
                Paris & Ile-de-France
              </div>
            </div>
          </div>
        </div>

        <div className="line-gold mt-16 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/30">
          <span>&copy; {new Date().getFullYear()} DestiDriving. Tous droits reserves.</span>
          <div className="flex gap-6">
            <Link to="/mentions-legales" className="hover:text-white/60 transition-colors">Mentions legales</Link>
            <Link to="/confidentialite" className="hover:text-white/60 transition-colors">Confidentialite</Link>
            <Link to="/CGV" className="hover:text-white/60 transition-colors">CGV</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
